import { render, staticRenderFns } from "./LeftColumn.vue?vue&type=template&id=1f5bfe5e&scoped=true&"
import script from "./LeftColumn.vue?vue&type=script&lang=js&"
export * from "./LeftColumn.vue?vue&type=script&lang=js&"
import style0 from "./LeftColumn.vue?vue&type=style&index=0&lang=css&"
import style1 from "./LeftColumn.vue?vue&type=style&index=1&id=1f5bfe5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f5bfe5e",
  null
  
)

export default component.exports